import React, { useEffect, useContext } from 'react'
import { StateController } from './../../App'

import VerticalCenter from '../../layouts/VerticalCenter/VerticalCenter'
import Button from '../atoms/Button'
import Icon from '../atoms/Icon'
import { sendDataLayer } from '../../utils/functions'

function CustomModal({
  show,
  setShowModal,
  primaryAction,
  secondaryAction,
  image,
  title,
  desc,
  cta,
  redemtion,
  status,
  noButton,
  datalayer,
  segment,
  classN
}) {
  const { setMdalOpen } = useContext(StateController)

  useEffect(() => {
    setMdalOpen(show);
    
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [show]);

  const close = () => {
    if (datalayer) {
      sendDataLayer({datalayer, repeat: true})
    }
    setShowModal(false)
    localStorage.setItem('endViewed', 'true')
    console.log("cerrar modal");
  }
  
  return (
    <div className={`mc-custom-modal ${show && 'mc-custom-modal__opened'} ${segment && segment === 'exito' && 'exito'} ${segment && segment === 'carulla' && 'carulla'} slow_ani ${classN && classN}`}>
      <div className="mc-custom-modal__overlay slow_ani" onClick={close}></div>
      <div className="mc-custom-modal__center">
        <VerticalCenter>
          <div className="mc-custom-modal__close" onClick={close}>
            <Icon name="close" />
          </div>
          <div className={`mc-custom-modal__center--window slow_ani ${status && 'status'}`}>
            <div>
              {image &&
                <div
                  className={`mc-custom-modal__center--window__image ${status && 'status'}`}
                  style={{"backgroundImage": `url(/assets/images/${image})`}}
                >
                </div>
              }
              <div className={`mc-custom-modal__center--window__title ${status && 'status'}`}>
                <div dangerouslySetInnerHTML={{ __html: title }} />
              </div>
              <div className={`mc-custom-modal__center--window__desc ${status && 'status'}`}>
                <div dangerouslySetInnerHTML={{ __html: desc }} />
              </div>
            </div>
            <div className={`mc-custom-modal__center--window__actions ${redemtion ? 'redemtion' : ''}`}>
              {!noButton &&
                <Button
                  type="secondary"
                  text={primaryAction ? primaryAction.buttonText : cta}
                  loading={primaryAction ? primaryAction.loading : false}
                  status="active"
                  onClick={primaryAction?.action || close}
                />
              }

              {secondaryAction &&
                <Button
                  type="primary"
                  text={secondaryAction.buttonText}
                  loading={false}
                  status="active"
                  onClick={secondaryAction.action}
                />
              }
            </div>

          </div>
        </VerticalCenter>
      </div>
    </div>
  )
}

export default CustomModal